import { FormikNetworkSelect } from '@/components/forms';

export default function PendleNetworkSelector() {
  return <FormikNetworkSelect name="chainId" label="Network" filterFn={(network) => !!network.canBeUsedForPendle} />;
}
